import { getModeledFeuds as getStoreItems } from 'selectors'
import { useSelector } from 'react-redux'

export const useFeuds = () => {
  const imported: any[] = useSelector(getStoreItems)
  const incomplete = imported.filter((item) => !item.complete)

  return { imported, incomplete }
}
